// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_0cO","cls2":"SelectionCitation-cls2_y46 SelectionCitation-cls1_0cO"};